var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "flex flex-col gap-4 sm:gap-5" }, [
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Current Medical Status")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 font-medium text-gray-400",
            },
            [
              _c("div", { staticClass: "mb-2" }, [
                _vm._v("Medical Conditions"),
              ]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                [
                  _c("li", [
                    _vm._v(_vm._s(_vm.data.medical_conditions || "N/A")),
                  ]),
                ]
              ),
              _c("div", { staticClass: "mt-4 mb-2" }, [
                _vm._v("Past Conditions"),
              ]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                [_c("li", [_vm._v(_vm._s(_vm.data.past_conditions || "N/A"))])]
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Medications")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 font-medium text-gray-400",
            },
            [
              _c("div", { staticClass: "mb-2" }, [
                _vm._v("Current Medications"),
              ]),
              _vm._l(_vm.data.client_medications, function (med, index) {
                return _c("div", { key: index, staticClass: "mb-4" }, [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                    },
                    [
                      _c("li", [_vm._v("Name: " + _vm._s(med.name || "N/A"))]),
                      _c("li", [
                        _vm._v("Dosage: " + _vm._s(med.dosage || "N/A")),
                      ]),
                      _c("li", [
                        _vm._v("Frequency: " + _vm._s(med.frequency || "N/A")),
                      ]),
                      _c("li", [
                        _vm._v(
                          "Medication File Attached: " +
                            _vm._s(med.file || "N/A")
                        ),
                      ]),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Allergies")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 font-medium text-gray-400",
            },
            [
              _c("div", { staticClass: "mb-2" }, [_vm._v("Food")]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                _vm._l(_vm.data.allergies_food, function (allergy) {
                  return _c("li", { key: allergy }, [
                    _vm._v(_vm._s(allergy || "N/A")),
                  ])
                }),
                0
              ),
              _c("div", { staticClass: "mt-4 mb-2" }, [_vm._v("Medication")]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                _vm._l(_vm.data.allergies_medication, function (allergy) {
                  return _c("li", { key: allergy }, [
                    _vm._v(_vm._s(allergy || "N/A")),
                  ])
                }),
                0
              ),
              _c("div", { staticClass: "mt-4 mb-2" }, [
                _vm._v("Environmental"),
              ]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                _vm._l(_vm.data.allergies_environmental, function (allergy) {
                  return _c("li", { key: allergy }, [
                    _vm._v(_vm._s(allergy || "N/A")),
                  ])
                }),
                0
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("DNR (Do Not Resuscitate)")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 font-medium text-gray-400",
            },
            [
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                [
                  _c("li", { staticClass: "capitalize" }, [
                    _vm._v("DNR Order: " + _vm._s(_vm.data.dnr_order || "N/A")),
                  ]),
                  _c("li", { staticClass: "capitalize" }, [
                    _vm._v(
                      "Copy Attached: " +
                        _vm._s(_vm.data.dnr_copy_attached || "N/A")
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Health Information"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }